import type { SelectedProductImage } from '../components/image-generation/ProductImageSelectionModal';

const trimText = (value?: string, maxLength = 180): string | undefined => {
  const text = value?.trim();
  if (!text) return undefined;
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const buildCompetitorAnalysisContext = (images: SelectedProductImage[]): string | undefined => {
  const competitorsById = new Map<number, NonNullable<SelectedProductImage['competitorSuggestions']>[number]>();

  images.forEach((image) => {
    if (!image.includeCompetitorAnalysis) return;
    image.competitorSuggestions?.forEach((competitor) => {
      competitorsById.set(competitor.id, competitor);
    });
  });

  const competitors = Array.from(competitorsById.values()).slice(0, 5);
  if (competitors.length === 0) return undefined;

  const lines = competitors.map((competitor, index) => {
    const details = [
      trimText(competitor.description),
      competitor.strengths ? `強み: ${trimText(competitor.strengths)}` : undefined,
      competitor.weaknesses ? `弱み: ${trimText(competitor.weaknesses)}` : undefined,
      competitor.company_url ? `URL: ${competitor.company_url}` : undefined,
    ].filter(Boolean);

    return `${index + 1}. ${competitor.name}${details.length > 0 ? ` - ${details.join(' / ')}` : ''}`;
  });

  return `競合情報を踏まえ、差別化できる訴求・構図を優先してください。\n${lines.join('\n')}`;
};
